import * as React from 'react';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { localizations } from '../../localization/localization';
import { Control, Form, ModelState, Errors } from 'react-redux-form';
import { TruckModel, DeleteReason } from '../TruckModels';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { DeletedReasonModel } from '../../common/models/CommonModels';
import FormItem from '../../components/forms/FormItem';
import { renderMultilineTextField } from '../../common/forms/FieldCreators';
import { momentToString } from '../../utils/dateUtilities';
import { connect } from 'react-redux';
import { RestrictedCompanyModel, DeleteReportProps } from '../../common/models/CommonModels';
import * as companyApi from '../../api/companyApi'
import * as trucksApi from '../../api/trucksApi';
import * as settingsApi from '../../api/settingsApi'
import * as validators from '../../common/validators/formValidators'
import { renderErrorInfoText } from '../../common/forms/FieldCreators';

const renderSelect = (props: any) => {
    return <Select style={{ minWidth: "160px" }} {...props}>{props.children}</Select>
}

type SubmitType = (values: any) => void;
type CancelType = () => void;

interface DeleteTruckDialogProps extends DialogPropsBase<SubmitType, CancelType> {
    truck: TruckModel,
    companyId: string;
}

type AllProps = DeleteTruckDialogProps & DeleteReportProps<DeleteReason>;

interface DeleteTruckState {
    isPartnerTrackingAllowed: boolean;
    reasons: DeletedReasonModel[],
    candidates: RestrictedCompanyModel[];
}

class DeleteTruckDialog extends React.Component<AllProps, DeleteTruckState> {

    constructor(props: AllProps) {
        super(props);

        this.state = {
            isPartnerTrackingAllowed: false,
            reasons: [],
            candidates: [],
        };
    }

    public componentDidMount() {
        trucksApi.getDeletedReasons().then(data => {
            companyApi.getRestrictionCandidates().then(candidateData => {
                settingsApi.getCompanyData(this.props.companyId).then(companySettings => {

                    const partnerTracking: boolean = companySettings && companySettings.allowPartnerTracking || false;

                    this.setState({
                        isPartnerTrackingAllowed: partnerTracking,
                        reasons: data,
                        candidates: candidateData
                    });
                });
            });
        });
    }

    public render() {
        const { truck, isOpen } = this.props;
        return <Dialog maxWidth={"lg"} open={isOpen}>
            <Form model="deleteTruck" onSubmit={this.props.onSubmit}>
                <DialogTitle title={localizations.trucks.actions.deleteTruck}>{localizations.trucks.actions.deleteTruck}</DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{localizations.trucks.deleteTable.departure}</TableCell>
                                <TableCell>{localizations.trucks.deleteTable.arrival}</TableCell>
                                <TableCell>{localizations.trucks.deleteTable.pointOfDeparture}</TableCell>
                                <TableCell>{localizations.trucks.deleteTable.pointOfArrival}</TableCell>
                                <TableCell>{localizations.trucks.licensePlateNumber}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{momentToString(truck.availableFrom)}</TableCell>
                                <TableCell>{momentToString(truck.availableTo)}</TableCell>
                                <TableCell>{truck.departureCity.name}</TableCell>
                                <TableCell>{truck.destinationCity && truck.destinationCity.name}</TableCell>
                                <TableCell>{truck.plateNumber}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <FormItem>
                        <FormControl>
                            <InputLabel key="reason-select">{localizations.common.reason}</InputLabel>
                            <Control.select model=".reason" required validators={{ required: validators.required }} component={renderSelect} id="reason-select" value={this.props.selectedReason}>
                                {this.state.reasons.map(item => <MenuItem key={item.id} value={DeleteReason[item.name]}>{localizations.trucks.deleteReasons[DeleteReason[item.name]]}</MenuItem>)}
                            </Control.select>
                            <Errors
                                model=".reason"
                                messages={{
                                    required: localizations.validation.required
                                }}
                                show={{ touched: true, focus: false }}
                                wrapper={renderErrorInfoText}
                            />
                        </FormControl>
                    </FormItem>
                    {this.props.selectedReason === DeleteReason.FoundCargoForTruckFromThisApp && this.state.isPartnerTrackingAllowed ? <FormItem>
                        <FormControl style={{ minWidth: 120 }}>
                            <InputLabel key="contractCompanyId-select">{localizations.company.company}</InputLabel>
                            <Control.select validators={{ required: validators.notUndefined }} validateOn={["blur", "change"]} model=".contractCompanyId" component={renderSelect} id="reason-contractCompanyId" value={this.props.candidate}>
                                {this.state.candidates.map(item => <MenuItem key={item.name} value={item.id}>{[item.name]}</MenuItem>)}
                            </Control.select>
                        </FormControl>
                        <Errors model={".contractCompanyId"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    </FormItem> : null}
                    <FormItem>
                        <Control.text id="reason-description" model=".deleteDescription" component={renderMultilineTextField} label= {localizations.actions.describeDeleteReason}/>
                    </FormItem>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={this.props.onCancel}>{localizations.actions.cancel}</Button>
                    <Button variant="contained" color="secondary" type="submit">{localizations.actions.delete}</Button>
                </DialogActions>
            </Form>
        </Dialog>
    }
}

const mapStateToProps = ({ deleteTruck }: ModelState) => {
    return {
        selectedReason: deleteTruck.reason,
        candidate: deleteTruck.contractCompanyId
    }
}

export default connect<any, any, any>(mapStateToProps)(DeleteTruckDialog);


// WEBPACK FOOTER //
// ./src/trucks/forms/DeleteTruckDialog.tsx